<template lang="html">
  <div class="become-the-change-cta">
    <h-btn class="small-top cta-btn" color="orange" dark @click="display=true" style="width=100%">
      <slot>Join Campaign</slot>
    </h-btn>
    <modal v-if="display">
      <div class="" slot="header">
        Hi! And welcome! Currently this is an invite only <b>Create The Change Campaign</b>.
        Just fill out this form and we'll get back to you ASAP with an invitation.
      </div>
      <div class="" slot="body">
        <form @submit.prevent="submit">
          <h-input label="First Name" outline required v-model="request.first_name"/>
          <h-input label="Last Name" outline required v-model="request.last_name"/>
          <h-input label="Email" type="email" name="" value="" outline required v-model="request.email"/>
          <div>
            What kind of change would you like to create in your life?
          </div>
          <textarea class="outline full-width" rows="5" required v-model="request.additional_information"></textarea>
          <div class="action-btns">
            <h-btn type="submit" color="orange" class="btn-submit" dark>Submit</h-btn>
            <h-btn flat @click="display=false" class="btn-close">Cancel</h-btn>
          </div>
        </form>
      </div>
      <div class="" slot="footer"></div>
    </modal>
  </div>
</template>

<script>
import modal from "@/components/modal";
import store from "@/services/api/store";
import snackbar from "@/services/hubs/snackbar";

const INVITATION_REQUEST_STORE = "InvitationRequest";

export default {
  components: { modal },
  props: ["campaign"],
  data() {
    return {
      display: false,
      request: {}
    };
  },
  methods: {
    submit() {
      let full = window.location.hostname;
      let sub = full.split(".")[0];
      sub = sub.toLowerCase();
      this.request.current_url = full;
      this.request.company_sub_domain = sub;
      this.request.came_from = document.referrer;
      this.request.campaign = this.campaign;
      store.create(INVITATION_REQUEST_STORE, this.request).then(() => {});
      this.display = false;
      snackbar.update("Saved");
    }
  }
};
</script>

<style lang="less" scoped>
.become-the-change-cta {
  font-weight: 500 !important;
  letter-spacing: 0px;
  line-height: 20px;
  width: 100%;
  .cta-btn {
    width: 100%;
  }
  .action-btns {
    display: flex;
    .btn-close {
      flex: 1;
    }
    .btn-submit {
      font-weight: 600;
      letter-spacing: 1px;
      flex: 3;
    }
  }
}
</style>
